import React from 'react';
import './App.css';

const GameNumber = ({gameNumber}) => {
    return (
        <div className="game-number-container">
            <p> Game Number: </p>
            <p className="number-readout game-number"> {gameNumber} </p>
        </div>
    );
}

export default GameNumber;



// WEBPACK FOOTER //
// ./src/components/GameNumber.js